export const set_range_amount = (range_amount,range_amount_percent) => ({ type: "SET_RANGE_AMOUNT_DATA", range_amount: range_amount, range_amount_percent: range_amount_percent })



// WEBPACK FOOTER //
// src/actions/rangeSliderActions.js